import React from 'react'
import { BATTLES_UNAVAILABLE } from 'containers/Schedule/components/NoBattlesMessage/translations'

import BattleRoomsSchedule from '../BattleRoomsSchedule/BattleRoomsSchedule'
import Title from '../Title/Title'

import styles from './FullSchedule.scss'

export function FullSchedule() {
    return (
        <section className={styles.base}>
            <Title>
                {BATTLES_UNAVAILABLE}
            </Title>
            <BattleRoomsSchedule type={'allBattleModes'}/>
        </section>
    )
}

export default FullSchedule



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/FullSchedule/FullSchedule.jsx